import {
  base64urlDecode,
  base64urlEncode,
  jsonStringifyWithUnicode,
} from "@repo/shared/utils";

/** Convert URLSearchParams to a plain object */
export const paramsToObject = (params: URLSearchParams) => {
  const map: Record<string, string | undefined> = Object.create(null);
  for (const [k, v] of params) map[k] = v;
  return map;
};

/** Pull parameters from hash url. If 'preserve' is false, they are removed from the url. */
export const pullUrlParams = (preserve: boolean = false) => {
  const params = new URLSearchParams(location.hash.slice(1));
  if (!preserve) {
    history.replaceState(null, "", location.href.replace(/#.*$/, ""));
  }
  return paramsToObject(params);
};

/** Add parameters to the hash url. If 'preserve' is true, parameters currently in the url are added. */
export const makeUrlParams = (
  parameters: Record<string, string>,
  preserve: boolean = false
) => {
  if (preserve) {
    const params = new URLSearchParams(location.hash.slice(1));
    parameters = {
      ...(paramsToObject(params) as Record<string, string>),
      ...parameters,
    };
  }
  return "#" + new URLSearchParams(parameters).toString();
};

/** Encode a JSON object as base64 in the url */
export const urlEncodeJSON = (value: unknown) => {
  return base64urlEncode(jsonStringifyWithUnicode(value));
};

/** Decode base64 encoded JSON from the url */
export const urlDecodeJSON = (json: string) => {
  return JSON.parse(base64urlDecode(json));
};
